// src/i18n.js
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import ElementLocale from 'element-ui/lib/locale';
import enLocale from 'element-ui/lib/locale/lang/en';
import ptLocale from 'element-ui/lib/locale/lang/pt-br';

Vue.use(VueI18n);

// 导入语言包
/* import en from './langs/en.json';
import pt from './langs/pt.json';

const messages = {
  en: en,
  pt: pt
}; */

const messages = {
  en: {
    date_format: 'yyyy-MM-dd HH:mm:ss',
    ...require('./langs/en.json'),
    ...enLocale
  },
  pt: {
    date_format: 'dd/MM/yyyy HH:mm:ss',
    ...require('./langs/pt.json'),
    ...ptLocale
  }
};

/* const savedLocal = localStorage.getItem('locale') || 'en'; */

const i18n = new VueI18n({
  locale: localStorage.getItem('locale') || 'en', // 设置默认语言
  messages
});

ElementLocale.i18n((key, value) => i18n.t(key, value));

export default i18n;